export default {
  colorScheme: 'Color Scheme',
  themeSettings: 'Theme Settings',
};
